module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-05.8e518b79.png";